export const SEGMENTS_MANAGER_TEXT = {
  pageTitle: 'Адміністрування сегментів',
  pageSubtitle: 'Керуйте відповідальними менеджерами для кожного сегмента ковенантів',
  refreshButton: 'Оновити',
  searchPlaceholder: 'Пошук за кодом сегмента, назвою або email',
  emptyTitle: 'Сегменти не знайдено',
  emptyDescription:
    'Після появи сегментів у сервісі вони будуть доступні для налаштування на цій сторінці.',
  emptySupervisors: 'Список порожній',
  segmentCodePrefix: 'Код сегмента',
  supervisorsCountPrefix: 'Відповідальних осіб',
} as const;

export const SEGMENTS_MANAGER_ARIA = {
  searchButton: 'Запустити пошук сегментів',
  clearSearchButton: 'Очистити пошук сегментів',
} as const;

export const SEGMENTS_MANAGER_ERRORS = {
  duplicateEmail: 'Цей email вже додано до цього сегмента',
} as const;
